"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArrowFillLeft;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowFillLeft(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "arrow-fill-left",
    className: "cls-1",
    d: "M37.34,11.79,71.25,45.71a6.07,6.07,0,0,1,0,8.58L37.34,88.21A6.07,6.07,0,0,1,27,83.92V16.08A6.07,6.07,0,0,1,37.34,11.79Z"
  })));
}